<template>
  <div class="index">
    <Headers></Headers>
    <div class="banner"
         style="background: url(/static/banner/services.png) center">
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">我们的服务</div>
          <div class="entitle">Our services</div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="listbox">
      <div class="container">
        <div v-for="(item, index) in list"
             :key="index"
             class="item">
          <div class="img">
            <img :src="item.cover_img"
                 alt=""
                 v-if="item.cover_img" />
            <img src="/static/news/1.png"
                 alt=""
                 v-else />
          </div>
          <div class="text">
            <div class="title">
              <span>0{{ index + 1 }}</span>{{ item.cate_name }}
            </div>
            <div class="info">
              {{ item.description }}
            </div>
            <div class="lists">
              <router-link :to="{
                  path: $Router.servicescontent.path,
                  query: {
                    id: item.id,
                  },
                }"
                           v-for="(item, index) in item.noSpecial"
                           :key="index">
                {{ item.title }}
              </router-link>
            </div>
            <router-link :to="{
                path: $Router.serviceslist.path,
                query: { cateid: item.cate_id },
              }"
                         class="more">
              ---- 查看更多 ----
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import service from './index'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'index',
  mixins: [setmeta],
  data () {
    return {
      cate_id: 3,
      columnLimit: 20,
      columnPage: 1,
      limit: 4,
      total: 0,
      page: 1,
      list: []
    }
  },
  components: {
    Headers,
    Footer
  },
  methods: {},
  created () {
    this.setMetaConfig({
      web_title: `服务项目-${this.$env.TITLE}`
    })
    service.getArtivleListByColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/services/index/index.vue